import calculateFeatureLimits from './calculate-feature-limits';
import limitDetectors from './limit-detectors';

export default {
  calculateFeatureLimits,
  limitDetectors,
};
